'use strict';
const colours=window.ICONS_COLOURS||{};
const ranges=window.ICONS_RANGES;
const range=window.ICONS_RANGE||'original';
const product=ranges[range];
let currency=window.ICONS_SHOP.currency;

const itemPrice=(type,count)=>{
  const p=window.ICONS_SHOP.products[type];
  const unit=p?.variants?.[0]?.price/100||ranges[type].unit;

  if(window.ICONS_SHOP.bundles&&currency==='AUD'){
    const offers=type==='kids'
      ? {1:15,2:25,3:30,4:40}
      : {1:20,2:35,3:45,4:60};

    return offers[count]??unit*count;
  }

  return unit*count;
};

const prices=Object.fromEntries(
  [1,2,3,4].map(n=>[n,itemPrice(range,n)])
);
const selectionKey=range==='original'
  ? 'icons-selection'
  : 'icons-selection-'+range;
const $=id=>document.getElementById(id);

const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(value);
let selections=['Ocean Blue'],activeSlot=0,cart=[],lastFocus;
try{const saved=JSON.parse(sessionStorage.getItem(selectionKey)||'null');if(Array.isArray(saved)&&saved.length<=4&&saved.every(n=>colours[n]))selections=saved;}catch{}
const requestedColour=new URLSearchParams(location.search).get('colour');if(colours[requestedColour])selections=[requestedColour];
const escapeHTML=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
function iconsColourAvailable(name){
 const p=window.ICONS_SHOP.products[range];
 return !!p?.variants?.some(v=>(v.option1===name||v.title===name)&&v.available);
}
function selectBundle(count){
 if(!prices[count]||!$('bundleSlots'))return;
 const defaults=['Ocean Blue','Baby Pink','Sage Green','Sky Blue'];
 selections=Array.from({length:count},(_,i)=>selections[i]||defaults[i]);activeSlot=Math.min(activeSlot,count-1);renderSelection();
}
function renderSelection(){
 if(!$('bundleSlots'))return;
 const firstAvailable=Object.keys(colours).find(iconsColourAvailable);
 if(!selections.length)selections=[firstAvailable||Object.keys(colours)[0]];
 if(firstAvailable)selections=selections.map(name=>iconsColourAvailable(name)?name:firstAvailable);
 activeSlot=Math.min(activeSlot,selections.length-1);
 sessionStorage.setItem(selectionKey,JSON.stringify(selections));
 const n=selections.length,price=prices[n];
 $('selectionPreview').style.display=n===1?'none':'';
 $('bundleSlots').innerHTML=selections.map((name,i)=>`<div class="bundle-slot"><label for="case-${i}">Case ${i+1}: Colour</label><select id="case-${i}" data-slot="${i}" aria-label="Colour for case ${i+1}">${Object.keys(colours).map(c=>`<option value="${c}" ${c===name?'selected':''} ${iconsColourAvailable(c)?'':'disabled'}>${c}${iconsColourAvailable(c)?'':' (Sold out)'}</option>`).join('')}</select></div>`).join('');
 $('selectionPreview').innerHTML=selections.map((name,i)=>`<button type="button" data-active-slot="${i}" class="${i===activeSlot?'active':''}" aria-label="Edit case ${i+1}, ${name}" aria-pressed="${i===activeSlot}"><img src="${colours[name]}" alt=""><span>${name}</span></button>`).join('');
 $('bundleHelper').textContent=`${n} ${n===1?'case':'cases'} · mix any colours`;
 $('bundleTotal').textContent=money(price);
 if(range==='original'&&n>1&&window.ICONS_SHOP.bundles&&currency==='AUD'){const saving=document.createElement('strong');saving.className='bundle-total-saving';saving.textContent=`Save ${money(n*20-price)}`;$('bundleTotal').append(' · ',saving);}
 $('addBundleBtn').textContent=`Add ${n===1?'to bag':n+' cases to bag'} · ${money(price)}`;
 $('pdpPrice').textContent=money(price)+(n>1?` / ${n} cases`:'');
 if($('stickyPrice'))$('stickyPrice').textContent=`${n} ${n===1?'case':'cases'} · ${money(price)}`;
 document.querySelectorAll('.bundle-card').forEach(b=>{const yes=+b.dataset.count===n;b.classList.toggle('active',yes);b.setAttribute('aria-pressed',yes);});
 syncGallery();
}
function syncGallery(){
 const name=selections[activeSlot];if(!$('mainProductImage'))return;
 $('mainProductImage').src=colours[name];$('mainProductImage').alt=`${name} ${product.label} case`;
 $('colourName').textContent=name;$('galleryCaption').textContent=`${name} · ${product.label}`;
 document.dispatchEvent(new CustomEvent('icons:colour',{detail:{name}}));
 document.querySelectorAll('.swatch').forEach(b=>{const active=b.dataset.name===name;b.classList.toggle('active',active);b.setAttribute('aria-pressed',active);});
}
function chooseColour(name){if(!colours[name]||!iconsColourAvailable(name))return;selections[activeSlot]=name;renderSelection();$('product')?.scrollIntoView({behavior:'smooth'});}
function addCurrent(){return window.IconsCommerce.addColours(range,[...selections]);}
function addPrinted(name){return window.IconsCommerce.addPrint(name);}
document.addEventListener('click',e=>{const b=e.target.closest('[data-print-add]');if(b)addPrinted(b.dataset.printAdd);});
function renderCart(){return window.IconsCommerce?.refresh();}
function removeItem(key){return window.IconsCommerce.remove(key);}
function openCart(){
 if(!$('cartDrawer'))return;lastFocus=document.activeElement;
 $('cartDrawer').removeAttribute('inert');$('cartDrawer').classList.add('open');$('cartDrawer').setAttribute('aria-hidden','false');$('overlay').classList.add('open');document.body.style.overflow='hidden';$('cartDrawer').querySelector('button')?.focus();
}
function closeCart(){if(!$('cartDrawer'))return;$('cartDrawer').classList.remove('open');$('cartDrawer').setAttribute('aria-hidden','true');$('cartDrawer').setAttribute('inert','');$('overlay').classList.remove('open');document.body.style.overflow='';lastFocus?.focus();}
document.addEventListener('keydown',e=>{
 if(!$('cartDrawer')?.classList.contains('open'))return;
 if(e.key==='Escape')closeCart();
 if(e.key==='Tab'){
  const list=[...$('cartDrawer').querySelectorAll('button:not(:disabled),a[href],select,input')];const first=list[0],last=list.at(-1);
  if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
 }
});
document.querySelectorAll('[data-bundle]').forEach(b=>b.addEventListener('click',()=>{selectBundle(+b.dataset.bundle);$('product').scrollIntoView({behavior:'smooth'});}));
document.querySelectorAll('.bundle-card').forEach(b=>b.addEventListener('click',()=>selectBundle(+b.dataset.count)));
document.querySelectorAll('.swatch').forEach(b=>b.addEventListener('click',()=>{if(!iconsColourAvailable(b.dataset.name))return;selections[activeSlot]=b.dataset.name;renderSelection();}));
$('bundleSlots')?.addEventListener('change',e=>{if(!e.target.matches('select'))return;activeSlot=+e.target.dataset.slot;selections[activeSlot]=e.target.value;renderSelection();$(`case-${activeSlot}`).focus({preventScroll:true});});
$('selectionPreview')?.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;activeSlot=+b.dataset.activeSlot;renderSelection();$(`case-${activeSlot}`)?.focus({preventScroll:true});});
const menu=$('mobileMenuBtn'),nav=$('primaryNav');menu?.addEventListener('click',()=>{const open=nav.classList.toggle('open');menu.setAttribute('aria-expanded',open);menu.textContent=open?'Close':'Menu';});
nav?.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{nav.classList.remove('open');menu.setAttribute('aria-expanded','false');menu.textContent='Menu';}));
document.querySelector('.show-colours')?.addEventListener('click',function(){const open=$('original-grid').classList.toggle('expanded');this.setAttribute('aria-expanded',open);this.textContent=open?'Show fewer colours':'View all 20 colours';});
const video=document.querySelector('.hero-full-video'),toggle=document.querySelector('.video-toggle');
toggle?.addEventListener('click',async()=>{if(video.paused){try{await video.play();toggle.textContent='Pause film Ⅱ';toggle.setAttribute('aria-label','Pause product video');}catch{toggle.textContent='Replay film ↗';}}else{video.pause();toggle.textContent='Play film ↗';toggle.setAttribute('aria-label','Play product video');}});
function wholesaleCount(){return [...document.querySelectorAll('.wholesale-quantity')].reduce((n,e)=>n+Number(e.value||0),0);}
document.querySelector('.order-form')?.addEventListener('input',()=>{document.querySelectorAll('.wholesale-quantity').forEach(e=>e.setCustomValidity(''));if($('wholesaleUnits'))$('wholesaleUnits').textContent=`${wholesaleCount()} cases selected`;});
if($('bundleSlots'))renderSelection();
if(video){video.muted=true;video.play().catch(()=>{});}

window.iconsSelections=()=>({range,names:[...selections]});
